export default __webpack_public_path__ + "img/beams.cad9520f.jpg";